<form [formGroup]="recalculateForm">
    <mat-form-field>
        <mat-select placeholder="Zoning code" [required]="true" formControlName="zoningCode">
            <mat-option *ngFor="let zoningCode of zoningCodes" [value]="zoningCode">
                {{zoningCode.Name}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <div class="checkbox-group">
        <div *ngFor="let type of CalculationErrorStatus; let i = index">
            <mat-checkbox class="example-margin" (change)="onChange($event)"
                [value]="getCalculationErrorStatusByType(type)">
                {{type}}</mat-checkbox>
        </div>
    </div>

    <div>
        <span>Threads Count</span><br>
        <mat-slider thumbLabel [displayWith]="safeValue" tickInterval="1" [min]="1"
            [max]="processService.availableThreadsCountValidated || 1" class="long-width-slider" showTickMarks>
            <input matSliderThumb formControlName="maxThreadsCount">
        </mat-slider>
        <span>{{maxThreadsCount}}</span>
    </div>
</form>